import { render, staticRenderFns } from "./comTerm1.vue?vue&type=template&id=7d90e76e&scoped=true&"
import script from "./comTerm1.vue?vue&type=script&lang=js&"
export * from "./comTerm1.vue?vue&type=script&lang=js&"
import style0 from "./comTerm1.vue?vue&type=style&index=0&id=7d90e76e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d90e76e",
  null
  
)

export default component.exports